import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useSelector } from 'react-redux';
import LimitedStockNotification from '../components/product-detail/limited-stock-notification/LimitedStockNotification';
import { makeGetProductSizes, makeGetSizeCombinationNotExist, makeGetSkuAvailability, } from '../redux/product/selectors/ProductSelector';
import { isOneSizeProduct } from '@as-react/common-utils';
const LimitedStockNotificationContainer = () => {
    const { oneSizeProductCode, market } = useAemConfig();
    const sizes = useSelector(makeGetProductSizes());
    const skuAvailability = useSelector(makeGetSkuAvailability());
    const sizeCombinationNotExist = useSelector(makeGetSizeCombinationNotExist());
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    return (_jsx(LimitedStockNotification, { skuAvailability: skuAvailability, isOneSizeProduct: oneSizeProduct, sizeCombinationNotExist: sizeCombinationNotExist, market: market }));
};
export default LimitedStockNotificationContainer;
